<div class="page-content page-container">
    <div class="padding">
        <div class="row container d-flex justify-content-center">
            <div class="col-xl-6 ">
                <div class="card user-card-full">
                    <div class="row m-l-0 m-r-0">
                        <div class="col-sm-4 bg-c-lite-green user-profile">
                            <div class="card-block text-center text-white">
                                <div class="m-b-25">
                                    <ng-container *ngIf="userinfo?.profile ==null || userinfo?.profile ==''"><img
                                            src="../../../../assets/images/profile.jpg" width="100%" class="img-radius"
                                            alt="User-Profile-Image"></ng-container>
                                    <ng-container *ngIf="userinfo?.profile !=null && userinfo?.profile !=''"><img
                                            [src]="userinfo?.profile" alt="user" width="100%" class="profile-pic">
                                    </ng-container>
                                </div>

                                <h6 class="f-w-600">{{userinfo?.nom}} {{userinfo?.prenom}}</h6>


                                <p> {{agence?.codeagence}}</p>
                                <i class=" mdi mdi-square-edit-outline feather icon-edit m-t-10 f-16"></i>
                            </div>
                        </div>
                        <div class="col-sm-8">
                            <div class="card-block">
                                <h6 class="m-b-20 p-b-5 b-b-default f-w-600">Information</h6>
                                <div class="row">
                                    <div class="col-sm-6">
                                        <p class="m-b-10 f-w-600">Telephone </p>
                                        <h6 class="text-muted f-w-400">{{userinfo.phone}}</h6>
                                    </div>

                                    <div class="col-sm-6">
                                        <p class="m-b-10 f-w-600">CNI</p>
                                        <h6 class="text-muted f-w-400">{{userinfo.cni}}</h6>
                                    </div>

                                    <div class="col-sm-6">
                                        <p class="m-b-10 f-w-600">{{'user' | translate}}</p>
                                        <h6 class="text-muted f-w-400">{{userinfo.email}}</h6>
                                    </div>
                                    <div class="col-sm-6">
                                        <p class="m-b-10 f-w-600">N° Session</p>
                                        <h6 class="text-muted f-w-400">{{session}}</h6>
                                    </div>
                                    <div class="col-sm-6">
                                        <p class="m-b-10 f-w-600">{{'password' | translate}}</p>
                                        <h6 class="text-muted f-w-400 ">
                                            <button class="btn btn-info "  (click)="changePassword()" >
                                                {{'modifier' | translate}}
                                            </button>
                                        </h6>
                                    </div>

                                </div>

                            </div>

                        </div>

                    </div>

                </div>

            </div>
            <div [formGroup]="passwordForm"  class=" col col-4" *ngIf="chgPassword">
                <h6>{{'NewPassword' | translate}}<br> </h6>

                      <mat-form-field appearance="outline">
                        <mat-label>
                            {{'currentPass' | translate}}
                        </mat-label>
                        <input
                          matInput
                          formControlName="currentPassword" tabindex="1"
                          placeholder="{{'required' | translate}}"
                          type="password"
                        />
                        <button
                          type="button"
                          mat-icon-button
                          matSuffix

                        >
                        <!-- [disabled]="(*ngIf="password$ | async") || !passwordForm.valid"  -->
                          <mat-icon color="primary">qr_code</mat-icon>
                        </button>
                        <!-- <div
                          *ngIf="
                          currentPassword.invalid &&
                            (currentPassword.dirty || currentPassword.touched)
                          "
                          class="alert alert-danger"
                        >
                          <div *ngIf="currentPassword.errors.required">
                            error message here
                          </div>
                        </div> -->
                      </mat-form-field>

                      <mat-form-field appearance="outline" >
                        <mat-label>
                            {{'newPass' | translate}}
                        </mat-label>
                        <input
                          matInput
                          formControlName="newPassword" tabindex="2"
                          placeholder="{{'required' | translate}}"
                          type="password"
                        />
                        <button
                          type="button"
                          mat-icon-button
                          matSuffix

                        >
                        <!-- [disabled]="(*ngIf="password$ | async") || !passwordForm.valid"  -->
                          <mat-icon color="primary">password</mat-icon>
                        </button>
                        <!-- <div
                          *ngIf="
                          currentPassword.invalid &&
                            (currentPassword.dirty || currentPassword.touched)
                          "
                          class="alert alert-danger"
                        >
                          <div *ngIf="currentPassword.errors.required">
                            error message here
                          </div>
                        </div> -->
                      </mat-form-field>

                      <mat-form-field appearance="outline" >
                        <mat-label>
                            {{'tryNewPass' | translate}}
                        </mat-label>
                        <input
                          matInput
                          formControlName="confirmPassword" tabindex="3"
                          placeholder="  {{'required' | translate}}"
                          type="password"
                        />
                        <button
                          type="button"
                          mat-icon-button
                          matSuffix

                        >
                        <!-- [disabled]="(*ngIf="password$ | async") || !passwordForm.valid"  -->
                          <mat-icon color="primary">password</mat-icon>
                        </button>
                        <!-- <div
                          *ngIf="
                          currentPassword.invalid &&
                            (currentPassword.dirty || currentPassword.touched)
                          "
                          class="alert alert-danger"
                        >
                          <div *ngIf="currentPassword.errors.required">
                            error message here
                          </div>
                        </div> -->
                      </mat-form-field>

                      <button class="btn btn-info " [disabled]="passwordForm.invalid" (click)="updatepassword()" *ngIf="validform">


                        <span *ngIf="!(password$ | async)">
                            {{'Confirmer' | translate}}
                        </span>
                          <mat-spinner
                            color="accent"

                            *ngIf="password$ | async"

                          >
                          </mat-spinner>
                   </button>
            </div>
            <button (click)="close()" style="
                height: 2em;
                color: red;
                /* background: black; */
                border-radius: 9px;
            ">
                <mat-icon> close</mat-icon>
            </button>
        </div>

    </div>

</div>


